var _rect, _rect2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(1 0 0 -1 0 180)",
    fill: "#FFDF00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.6 83.5545L112.285 64.4945C109.983 60.6112 105.779 58.2303 101.227 58.2303H77.4399C72.8882 58.2303 68.6837 60.6112 66.3821 64.4945L55.0672 83.5545C54.2829 84.8786 53.7814 86.3046 53.5243 87.7688H27.4614C27.7186 86.3046 28.22 84.8786 29.0044 83.5545L53.5371 42.2642C55.8387 38.3809 60.0432 36 64.5949 36H114.072C118.624 36 122.828 38.3809 125.13 42.2642L142.076 70.7841C144.661 74.8584 151.347 83.9619 161.376 87.7688H125.155C124.885 86.3173 124.384 84.8786 123.6 83.5545Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.063 109.21L125.13 137.73C122.815 141.614 118.611 143.995 114.072 143.995H64.5949C60.0432 143.995 55.8387 141.614 53.5371 137.73L29.0044 96.44C28.22 95.1158 27.7186 93.6898 27.4614 92.2256H53.5114C53.7686 93.6898 54.27 95.1158 55.0544 96.44L66.3693 115.5C68.6708 119.383 72.8753 121.764 77.427 121.764H101.214C105.766 121.764 109.97 119.383 112.272 115.5L123.587 96.44C124.371 95.1158 124.872 93.6898 125.13 92.2256H161.35C151.334 96.0326 144.661 105.136 142.063 109.21Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/app_icon.d22f52666cd39f03bf6622e573e16a23.svg";
export { ForwardRef as ReactComponent };